import { render, staticRenderFns } from "./CollegeEdit.vue?vue&type=template&id=28ea5c2d&scoped=true&"
import script from "./CollegeEdit.vue?vue&type=script&lang=js&"
export * from "./CollegeEdit.vue?vue&type=script&lang=js&"
import style0 from "./CollegeEdit.vue?vue&type=style&index=0&id=28ea5c2d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ea5c2d",
  null
  
)

export default component.exports